import styled from '@emotion/styled'
import theme from '../../../styles/theme'
import { InfoMedium500Style } from '../../../styles/Text.styles'

// Interface for Badge props
interface BadgeProps {
  disabled?: boolean
}

export const Badge = styled.div<BadgeProps>`
  ${InfoMedium500Style};

  background-color: ${({ disabled }) =>
    disabled ? '#FFFFFF' : theme.colors.second};
  color: ${({ disabled }) => (disabled ? '#e7e7e7' : 'white')};
  border-radius: 2rem;
  padding: 0.2rem 1.5rem;
  font-style: italic;
  margin-right: 1rem;
  margin-left: 0.5rem;
  //dotted border
  border: 1px dotted ${'#c4c4c4'};
`
